import React from "react";

const faq = () => {
    const FAQ = {
        Question1: "اهميت و نياز صنعت به دستگاه های ساخت شرکت را بیان نمایید ؟",
        Answer1: 'بيش از 100برابر شدن توليد، مرهون استفاده از فناوري هاي جديد در توليد دستگاههاي صنعتي است، همچنين کاهش چشمگير نيروي انساني مرهون فناوريهاي اتوماسيون است. بنابراین استفاده از فناوريهاي نوين و اتوماسيون صنعتي باعث ايجاد ارزش افزوده با نرخ بالا شده که عامل اصولي ايجاد ثروت در جامعه، ايجاد اشتغال مولد و افزايش سطح رفاه در جامعه است',

        Question2: "کیفیت محصولات ساخت شرکت آپافن در مقایسه با محصولات خارجی و داخلی چگونه است؟",
        Answer2: 'تنها رقباي خارجي محصولات ساخت کشورهاي ترکيه و ايتاليا است. که محصولات ترکيه هاي از کيفيت پايينتري نسبت به محصولات ايتاليايي و شرکت آپافن برخوردارند. همچنين از معايب محصولات رقيب ميتوان به عدم وجود نمايندگي مجاز و خدمات پس از فروش بوده و بيش از %90اين محصولات دست دوم و مستعمل بوده که توسط واردکنندگان دستگاههاي ريسندگي براي تامين حداقل نياز خريدار وارد مي شوند. ',


        Question3: "مزایای محصولات آپافن نسبت به محصولات مشابه چیست؟",
        Answer3: 'نکات مثبت موجود در انواع ماشین آلات مشابه در طراحی صورت گرفته برای محصولات لحاظ گردیده است. با طراحی جدید و هوشمندانه استهلاک موتور نسبت به نمونه های خارجی بسیار کمتر است. صرفه جویی و کاهش هزینه ها به طور چشم گیری مقرون به صرفه تر است لذا میتوان به آن به عنوان یک کالای سرمایه ای نگاه کرد. عملکرد، سرعت و مکانیزم دستگاه  ها با توجه به نیاز مشتری بومی سازی شده است.',
    }
    return (
        <div className="col col-lg-6 col-lg-offset-1">
            <div className="faq-section">
                <div className="section-title-s3">
                    <span>سؤالات متداول</span>
                    <h2>دستگاه های تخصصی، عضوی از تیم کاری ما است .</h2>
                </div>
                <div className="details">
                    <p>به منظور آشنایی هرچه بیشتر با این اعضا پاسخگوی کلیه سوالات شما هستیم</p>
                    <div className="panel-group faq-accordion theme-accordion-s1" id="accordion">



                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne"
                                    aria-expanded="true">{FAQ.Question1}</a>
                            </div>
                            <div id="collapseOne" className="panel-collapse collapse in">
                                <div className="panel-body">
                                    <p>{FAQ.Answer1} </p>
                                </div>
                            </div>
                        </div>




                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <a className="collapsed" data-toggle="collapse" data-parent="#accordion"
                                    href="#collapseTwo">{FAQ.Question2}</a>
                            </div>
                            <div id="collapseTwo" className="panel-collapse collapse">
                                <div className="panel-body">
                                    <p>{FAQ.Answer2}</p>
                                </div>
                            </div>
                        </div>




                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <a className="collapsed" data-toggle="collapse" data-parent="#accordion"
                                    href="#collapseThree">{FAQ.Question3} </a>
                            </div>
                            <div id="collapseThree" className="panel-collapse collapse">
                                <div className="panel-body">
                                    <p>{FAQ.Answer3} </p>
                                </div>
                            </div>
                        </div>







                    </div>
                </div>
            </div>
        </div>
    );
};

export default faq;